__webpack_require__.p = "https://adjika.ctl-erp.ru/build/";